
















import {Component, Vue, Prop} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';
import {enhancedEcommerce} from '../../shared/helpers/enhanced-ecommerce';

@Component({
  name: 'catalog-product-list',
  components: ServiceContainer().getComponents()
})

export default class extends Vue {
  @Prop({required: true}) readonly dataSource: string;
  @Prop({default: null}) readonly categoryImage!: string | null;


  private get isLoading(): boolean {
    return this.$store.getters[`${this.dataSource}/isLoading`];
  }

  private get products(): Array<object> {
    return this.$store.getters[`${this.dataSource}/productList`];
  }

  private created(): void {
    enhancedEcommerce.addProductImpressions(this.products);
  }

  private updated(): void {
    setTimeout(() => {
      ('.catalog__category-list a h2').matchHeight(true);
    }, 100);
  }
}
